import React from 'react';
import './index.css';
import HeroSection from './components/HeroSection/HeroSection';
import SectionDivider from './components/SectionDivider/SectionDivider';
import AboutSection from './components/AboutSection/AboutSection';
import SkillsBouncing from './components/SkillsBouncing/SkillsBouncing';
import Portfolio from './components/Portfolio/Portfolio';
import ContactSection from './components/ContactSection/ContactSection';

function App() {
  return (
    <div className="App">

      <HeroSection />
      <SectionDivider />
      <AboutSection />
      <SectionDivider />
      <SkillsBouncing />
      <SectionDivider />
      <Portfolio />
      <SectionDivider />
      <ContactSection />
    </div>
  );
}

export default App;
